import { Box, IconButton, Typography } from '@mui/material';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import FlightRoundedIcon from '@mui/icons-material/FlightRounded';
import jetxpressHero from '../../../assets/games/jetxpress.jpg';
import './FairAviatorLobbyScreen.css';

// export const FAIR_AVIATOR_ENTRY_FEES = [100, 50, 25, 15, 10];
export const FAIR_AVIATOR_ENTRY_FEES = [10];

const TIER_META = {
  // 100: { label: 'Premium', tag: 'POPULAR' },
  // 50: { label: 'Standard', tag: 'FAIR' },
  // 25: { label: 'Quick', tag: 'FAIR' },
  // 15: { label: 'Lite', tag: 'FAIR' },
  10: { label: 'Starter', tag: 'LIVE' },
};

function FairAviatorLobbyScreen({ onBack, onSelectTier }) {
  return (
    <Box className="fairaviator-lobby jetxpress-lobby">
      <header className="fairaviator-lobby__header">
        <IconButton size="small" onClick={onBack} sx={{ color: '#fff' }}>
          <ArrowBackIosNewRoundedIcon fontSize="small" />
        </IconButton>
        <Box>
          <Typography className="fairaviator-lobby__title">
            <span className="jetxpress-brand__jet">jet</span>
            <span className="jetxpress-brand__xpress">Xpress</span>
          </Typography>
          <Typography className="fairaviator-lobby__subtitle">
            Last to cash out gets the highest!
          </Typography>
        </Box>
      </header>

      <Box className="fairaviator-lobby__scroll">
        <Box className="jetxpress-hero">
          <img src={jetxpressHero} alt="jetXpress" className="jetxpress-hero__img" />
          <Box className="jetxpress-hero__overlay" />
          <Typography className="jetxpress-hero__tagline">
            Last to cash out <span>gets the highest!</span>
          </Typography>
        </Box>

        <Typography className="fairaviator-lobby__section">Choose your table</Typography>

        {FAIR_AVIATOR_ENTRY_FEES.map((fee) => {
          const meta = TIER_META[fee];
          return (
            <button
              key={fee}
              type="button"
              className="fairaviator-tier-card"
              onClick={() => onSelectTier(fee)}
            >
              <Box className="fairaviator-tier-card__icon">
                <FlightRoundedIcon />
              </Box>
              <Box className="fairaviator-tier-card__body">
                <Box className="fairaviator-tier-card__head">
                  <Typography className="fairaviator-tier-card__amount">₹{fee}</Typography>
                  <span className="fairaviator-tier-card__tag">{meta.tag}</span>
                </Box>
                <Typography className="fairaviator-tier-card__label">{meta.label} table</Typography>
                <Typography className="fairaviator-tier-card__desc">
                  Fixed ₹{fee} · cash out before crash · rank by timing
                </Typography>
              </Box>
              <span className="fairaviator-tier-card__play">Play →</span>
            </button>
          );
        })}
      </Box>
    </Box>
  );
}

export default FairAviatorLobbyScreen;
